import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext, useRef, useState } from "react";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import { createOrganization } from "../../service/User";
import Cookies from "js-cookie";
import { uploadFileToS3 } from "../../service/S3Bucket"; // Import the S3 upload function
import { RxCross2 } from "react-icons/rx";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";
import uploadFile from "../../assets/uploadFile.png"

export default function CreateOrganization({
  open,
  setOpen,
  fetchorgnizationlist,
}) {
  const [isLoading, setIsLoading] = useState(false); // State to manage loading
  const [selectedOrgName, setSelectedOrgName] = useState("");
  const [logo, setLogo] = useState(null);
  const cancelButtonRef = useRef(null);
  const fileInputRef = useRef(null);
  const { theme, langMode } = useContext(AppContext);
  const handleOrgNameChange = (event) => {
    setSelectedOrgName(event.target.value);
  };
  const handleLogoChange = (event) => {
    setLogo(event.target.files[0]);
  };
  const handleAddOrganization = async () => {
    setIsLoading(true); // Start loading
    const token = Cookies.get("accessToken");
    try {
      let logoUrl = "";
      if (logo) {
        logoUrl = await uploadFileToS3(logo);
      }
      const data = await createOrganization(selectedOrgName, logoUrl, token);
      if (data.header.code === 600) {
        toast.success("Organization Added");
        setSelectedOrgName("");
        setLogo(null); // Clear logo state
        setOpen(false);
        fetchorgnizationlist();
      } else {
        toast.error(data.body.value);
      }
    } catch (error) {
      toast.error("Error creating organization");
    } finally {
      setIsLoading(false); // End loading
    }
  };

  const handleClick = () => {
    fileInputRef.current.click(); // This opens the file upload modal
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity`}
          />
        </Transition.Child>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                  theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }`}
              >
                <div
                  className={`bg-white rounded-lg shadow ${
                    theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                  }`}
                >
                  <div className="flex items-center justify-between p-2 md:p-5 rounded-t dark:border-gray-600">
                    <h3 className="text-base font-bold text-[#000000] dark:text-white">
                      {translations[langMode].addOrganization}
                    </h3>
                    <button
                      type="button"
                      className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-[20px] h-[20px] ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      data-modal-hide="small-modal"
                      onClick={() => setOpen(false)}
                    >
                      <RxCross2 />
                      <span className="sr-only">Close modal</span>
                    </button>
                  </div>
                  <div className="p-4 grid grid-cols-1 gap-x-8 xsm:gap-y-10 gap-y-6 sm:grid-cols-4">
                    <div className="col-span-12">
                      <div className="relative flex xsm:flex-row flex-col gap-y-3 xsm:justify-between justify-start xsm:items-center items-start">
                        <label
                          className={`block text-[14px] font-medium text-[#000000] ${
                            theme === "dark"
                              ? "dark-mode "
                              : theme === "high-contrast"
                              ? "high-contrast  "
                              : ""
                          }`}
                        >
                          {translations[langMode].orgname}
                        </label>
                        <input
                          type="text"
                          value={selectedOrgName}
                          onChange={handleOrgNameChange}
                          placeholder={translations[langMode].entername}
                          className={`mt-1 block max-w-[220px] w-full rounded-md border border-[#777777] shadow-sm
                             focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50 sm:text-sm ${
                               theme === "dark"
                                 ? "dark-mode "
                                 : theme === "high-contrast"
                                 ? "high-contrast  "
                                 : ""
                             }`}
                        />
                      </div>
                    </div>
                    <div className="col-span-12">
                      <div className="relative flex xsm:flex-row flex-col gap-y-3 xsm:justify-between justify-start xsm:items-center items-start">
                        <label
                          className={`block text-[14px] font-medium text-[#000000] ${
                            theme === "dark"
                              ? "dark-mode "
                              : theme === "high-contrast"
                              ? "high-contrast  "
                              : ""
                          }`}
                        >
                          {translations[langMode].OrganizationLogo}
                        </label>
                        <div
                        style={{
                          width: "293px",
                          height: "100px",
                          border: "1px solid #D1D5DB80",
                          borderRadius: "10px",
                          padding: "10px"
                        }}>
                          <div style={{ border: "1px dashed  #236DB4" }} className="flex flex-col items-center h-full p-[10px]" onClick={handleClick} >
                            <img src={uploadFile} className="w-[34px] h-[34px]" />
                            <p className="text-[#111827] text-[12px] font-medium">{translations[langMode].uploadOrganizationLogo}</p>
                            <input type="file" className="hidden" ref={fileInputRef}
                              onChange={handleLogoChange} />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600 gap-3">

                    <button
                      onClick={handleAddOrganization}
                      className={`${isLoading ? "cursor-not-allowed" : ""} bg-[#236DB4] text-white text-[12px] font-bold p-[10px] rounded-[4px] xsm:max-w-25 w-full whitespace-nowrap`}
                      disabled={isLoading}
                    >
                     {translations[langMode].save}
                    </button>

                    <button
                      onClick={() => setOpen(false)}
                      className="border border-[#236DB4] text-[#236DB4] text-[12px] font-bold p-[10px] rounded-[4px] xsm:max-w-25 w-full"
                    >
                      {translations[langMode].cancel}
                    </button>

                    {/* <button
                      type="button"
                      onClick={handleAddOrganization}
                      className={`text-white ${
                        isLoading
                          ? "bg-gray-500 cursor-not-allowed"
                          : "bg-blue-800 hover:bg-blue-800"
                      } focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1.5 ml-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                      disabled={isLoading}
                    >
                      {isLoading
                        ? translations[langMode].creating
                        : translations[langMode].create}
                    </button> */}

                  
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
